//import Libraries
import React, { Component } from 'react';

//import Components

//import Styles
import './QuantitySelector.css'

const quantitySelector = (props) => {
    return (
        <div>
            <input
                type="number"
                name="quantity"
                onChange={props.handleOnChange}
                value={props.value} />
        </div>
    );
}

export default quantitySelector;


// WEBPACK FOOTER //
// ./src/pages/Store/Props/QuantitySelector.js